import React from 'react'
import { Link } from 'react-router-dom'
import { clickGTM } from '../../services/Gtm/gtmInteractions'

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  const [year, month, day] = dateStr.split('-')
  return `${day}/${month}/${year}`
}

const HeaderCampaign = ({ campaignData, token }) => {
  const { handleClick } = clickGTM()
  const isNewCampaignFreeDays = process.env.REACT_APP_IS_NEW_CAMPAIGN_FREE_DAYS === 'true'
  const validFrom = formatDate(campaignData?.data?.valid_from)
  const validUntil = formatDate(campaignData?.data?.valid_until)

  const currentDays = process.env.REACT_APP_CURRENT_NUMBER_FREE_DAYS
  const futureDays = process.env.REACT_APP_FUTURE_NUMBER_FREE_DAYS

  return (
    <div className="wellcome_area wellcome_area_campaign clearfix" id="home">
      <div className="container h-100">
        <div className="row h-100 align-items-center">
          <div className="col-12 col-md-7 col-lg-6 header-content">
            <div className="wellcome-heading">
              <h2>
                <span className="text-white text-uppercase">
                  ¡Promoción {campaignData?.data?.discount_percentage ?? ''}% de descuento!
                </span>
              </h2>
              <p>
                <strong className="text-white  d-block mb-3">
                  Tus compras de supermercado en{' '}
                  <span>
                    tiendas Wong, Wong.pe y App Wong{' '}
                  </span>{' '}
                  con descuentos exclusivos.
                </strong>
              </p>
              <p>
                <strong className="text-white  d-block mb-3">
                  Envío gratis e ilimitados, doble acumulación de Puntos Bonus y mucho más.                
                </strong>
              </p>
              <p>
                <strong className="text-white  d-block mb-3">Promoción valida desde el {validFrom} hasta el {validUntil} exclusivamente para usuarios que se suscriban mediante wongprime.pe. 
                    <br />
                    <br />
                  <strong>*Beneficio aplicable únicamente en el primer cobro.</strong>
                </strong>
              </p>
              <strong className="d-block text-white">
                Prueba desde hoy 15 días gratis.
              </strong>
            </div>
            <div className="get-start-area">
              <Link
                className="submit"
                to={`/auth/register-campaign?token=${token}`}
                onClick={(e) => {
                  handleClick(e, 'Home - Body')
                }}>
                {' '}
                <i className="fa fa-bookmark"></i> Suscríbete aquí
              </Link>
              <p>
                <strong className="d-block" style={{ color: 'white' }}>* Válido para compras desde S/ 79.90</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderCampaign